import React, { useContext, useEffect } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';

export function NarrativesList({ variant = 'buttons' }) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $narr = context.$narr;

  const def = context.me ? 'simple' : 'public';
  useEffect(() => {
    if (context.state.version !== 'β' && context.getNarrative(context.narrativeCurrent).beta) {
      context.setNarrativeCurrent(def);
    }
  }, [context.state.version, context.narrativeCurrent]);

  const options = context.narratives
    ? Object.keys(context.narratives)
      .filter(oneNarrative => !context.getNarrative(oneNarrative).beta || context.state.version === 'β')
      .filter(oneNarrative => context.narratives[oneNarrative].user_choose)
      .filter(oneNarrative => !context.getNarrative(oneNarrative).utility)
      .sort((a, b) => context.narratives[b].order - context.narratives[a].order)
    : [];

  if (variant === 'select') {
    if (!options.length) return null;
    const value = options.includes(context.narrativeCurrent) ? context.narrativeCurrent : options[0];
    return (
      <select
        className="x_guide_narrative_select"
        value={value}
        onChange={(e) => context.setNarrativeCurrent(e.target.value)}
        aria-label={$narr(value, 'trigger')}
      >
        {options.map(oneNarrative => (
          <option key={oneNarrative} value={oneNarrative}>
            {$narr(oneNarrative, 'trigger')}
          </option>
        ))}
      </select>
    );
  }

  return (
    <div className="x_edu_narrative_choose">
      {options.map(oneNarrative =>
        <div
          onClick={() => {
            context.setNarrativeCurrent(oneNarrative);
          }}
          key={`${oneNarrative}`}
          className={context.narrativeCurrent === oneNarrative ? "x_edu_narrative1 active" : "x_edu_narrative1"}
        >
          {$narr(oneNarrative, 'trigger')}
        </div>
      )}
      <div className="x_edu_narrative_choose_line" />
    </div>
  );
}
